(function (Wishlist, $) {

  var $wishlistButton = $('.wishlist-btn');
  var $wishlistAddedButton = $('.wishlist-added');
  var $wishlistTile = $('.Grid__Cell_WishList');
  var $wishlistItemCount = $('.wishlist-item-count');
  var numProductTiles = $wishlistTile.length;
  var wishlist = localStorage.getItem('user_wishlist') || [];
  if (wishlist.length > 0) {
    wishlist = JSON.parse(localStorage.getItem('user_wishlist'));
  }

  /*
   * Update button to show current state (gold for active)
   */   
  var animateWishlist = function (self) {
    $(self).toggleClass('is-active');
    $(self).removeClass('is-active-without-trans');
    // console.log('init');
  };

  /*
   * Add/Remove selected item to the user's wishlist array in localStorage
   * Wishlist button class 'is-active' determines whether or not to add or remove
   * If 'is-active', remove the item, otherwise add it
   */   
  var updateWishlist = function (self) {
    document.dispatchEvent(new CustomEvent("theme:loading:start"));
    var productHandle = $(self).attr('data-product-handle');
    var productVariantId = $(self).attr('data-product-variant-id');
    var isRemove = $(self).hasClass('is-active');
    /* Remove */
    if (isRemove) {
      let removeIndex = wishlist.findIndex(wishlist => {
          return wishlist.variant == productHandle;
      });
      /* hide wishlish item when it remove at wishlist page */
      if (window.location.href.indexOf('pages/wishlist') > -1) {
        $wishlistTile.each(function () {
          var productVariantId = $(this).attr('data-product-variant-id');
          let index = wishlist.findIndex(wishlist => {
              return wishlist.variant == productVariantId;
          });
          if (index >= 0) {
            wishlist.splice(removeIndex, 1);
      		localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
            $(this).fadeOut();
            numProductTiles--;
            return false;
          }
        });
        if (numProductTiles == 0) {
          $('.EmptyState').addClass('is_visible');
          $('.wishlist-hero').removeClass('is_visible');
        } else {
          $('.EmptyState').removeClass('is_visible');
          $('.wishlist-hero').addClass('is_visible');
        }
      }else{
        wishlist.splice(removeIndex, 1);
      	localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
        // $(self).text('Add to Wishlist');
        $wishlistAddedButton.hide();
      
      }
    }
    /* Add */ 
    else {
      var newProduct = {
        "handle":  productHandle,
        "variant":  productVariantId
      }
      wishlist.push(newProduct);
      localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
      // $(self).text('Remove from wishlist');
      $wishlistAddedButton.show();
    }
    console.log(JSON.stringify(wishlist));
    document.dispatchEvent(new CustomEvent("theme:loading:end"));
    if(!isRemove)  {
    	// heartFalling();
    }
    
  };

  /*
   * Loop through wishlist buttons and activate any items that are already in user's wishlist
   * Activate by adding class 'is-active'
   * Run on initialization
   */   
  var activateItemsInWishlist = function () {
    $wishlistButton.each(function () {
      var productHandle = $(this).attr('data-product-handle');
      let index = wishlist.findIndex(wishlist => {
          return wishlist.handle == productHandle;
      });
      if (index > -1) {
        $(this).addClass('is-active');
        $(this).addClass('is-active-without-trans');
      }
      
      if (window.location.href.indexOf('pages/wishlist') === -1) {
        if (index > -1) {
          // $(this).text('Remove from wishlist');
          $wishlistAddedButton.show();
        }else{
          // $(this).text('Add to Wishlist');
          $wishlistAddedButton.hide();
        }
      }
    });
  };

  /*
   * Loop through product titles and remove any that aren't a part of the wishlist
   * Decrement numProductTiles on removal
   */   
  var displayOnlyWishlistItems = function () {
    $wishlistTile.each(function () {
      var productVariantId = $(this).attr('data-product-variant-id');
      let index = wishlist.findIndex(wishlist => {
          return wishlist.variant == productVariantId;
      });
      if (index === -1) {
        $(this).remove();
        numProductTiles--;
      }
    });
  };

  /*
   * Check if on the wishlist page and hide any items that aren't a part of the wishlist
   * If no wishlist items exist, show the empty wishlist notice
   */   
  var loadWishlist = function () {
    if (window.location.href.indexOf('pages/wishlist') > -1) {
      displayOnlyWishlistItems();
      $('.wishlist-loader').fadeOut(2000, function () {
        $('.wishlist-grid').addClass('is_visible');
        console.log(numProductTiles);
        if (numProductTiles == 0) {
          $('.EmptyState').addClass('is_visible');
          $('.wishlist-hero').removeClass('is_visible');
        } else {
          $('.EmptyState').removeClass('is_visible');
          $('.wishlist-hero').addClass('is_visible');
        }
      });
    }
  };

  /**
   * Display number of items in the wishlist
   * Must set the $wishlistItemCount variable
   */
  var updateWishlistItemCount = function () {
    if (wishlist) {
      $wishlistItemCount.text(wishlist.length);
    }
  };

  var bindUIActions = function () {
    $wishlistButton.click(function (e) {
      e.preventDefault();
      updateWishlist(this);
      animateWishlist(this);
    });
  };

  Wishlist.init = function () {
    bindUIActions();
    activateItemsInWishlist();
    loadWishlist();
    updateWishlistItemCount();
  };

}(window.Wishlist = window.Wishlist || {}, jQuery, undefined));
